import { render, staticRenderFns } from "./LicenciaOficialColectivaTabContent.vue?vue&type=template&id=93aac618"
import script from "./LicenciaOficialColectivaTabContent.vue?vue&type=script&lang=js"
export * from "./LicenciaOficialColectivaTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports